import React from "react";
import { Link } from "react-router-dom";

function Tag(props){

    function handleClick(){
        if (props.clickFunction !== undefined && props.clickFunction !== null){
            props.clickFunction(props.id);
        }
    }

    const className = "btn btn-light tag-pill" + (props.isSelected ? " is-selected" : "");

    return(
        <div className="tag">
            {props.clickFunction !== undefined && props.clickFunction !== null ?
            <button type="button" className={className} onClick={handleClick} aria-pressed={!!props.isSelected}>{props.tagName}</button> :
            <Link to={props.clickFunction !== undefined && props.clickFunction !== null ? "" : "/szukaj"}
            type="button" className={className} onClick={handleClick}>{props.tagName}</Link>
        }
        </div>
    )
}

export default Tag;